import { type HTMLAttributes } from 'react'
import styles from './Pill.module.css'

type PillProps = HTMLAttributes<HTMLSpanElement> & {
  size?: 'sm' | 'md'
  strong?: boolean
  tone?: 'default' | 'muted' | 'primary'
}

export const Pill = ({
  children,
  className,
  size = 'sm',
  strong = false,
  tone = 'default',
  ...props
}: PillProps) => (
  <span
    className={[
      styles.pill,
      styles[size],
      styles[tone],
      strong ? styles.strong : '',
      className
    ].filter(Boolean).join(' ')}
    {...props}
  >
    {children}
  </span>
)
